// extracted by mini-css-extract-plugin
module.exports = {"header":"ConfirmDialog_header__DQeBK"};